import Skeleton from 'flow/components/ui-components/Skeleton';

const SkeletonSummary = () => (
    <Skeleton>
        <div className="flex w-full flex-col gap-2 py-1">
            <Skeleton.Text className="h-3 w-5/6" />
            <Skeleton.Text className="h-3 w-3/4" />
            <Skeleton.Text className="h-3 w-2/3" />
        </div>
    </Skeleton>
);

export default SkeletonSummary;
